export const TEST_ID_CHECKOUT_DISCLAIMER = 'checkout-disclaimer';
export const TEST_ID_SUSCRIBABLE_DISCLAIMER = 'suscribable-disclaimer';
export const TEST_ID_SHIPPING_DISCLAIMER = 'shipping-disclaimer';
export const TEST_ID_INTRO_PRODUCT_DISCLAIMER = 'intro-product-disclaimer';
